import { render } from "./lyra-citation.vue?vue&type=template&id=8ed62728&ts=true"
import script from "./lyra-citation.vue?vue&type=script&lang=ts"
export * from "./lyra-citation.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\DEV FOLDER\\PFIZER EPIC-HR and Virology\\pfizer-covid-antiviral-digital\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__